export default __webpack_public_path__ + "static/media/redemption-icon.6c44ef5c.svg";